<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-27 15:27:18
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-27 15:54:31
 * @FilePath: \partner.chaoyongtuan.com\src\components\ui\idTag\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-tooltip placement="top">
		<div slot="content">
			<span>{{ label }}</span>
			<span class="ml-4">{{ id }}</span>
			<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(id)"></i>
		</div>
		<div class="id-tag ml-2 radius-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
	</el-tooltip>
</template>
<script>
import { copy } from '@/utils/common';
export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		id: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
};
</script>
<style lang="less" scoped>
.id-tag {
	padding: 0 3px;
	border-radius: 3px;
	background-color: @color-gy2;
}
</style>